import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
/**
 * Modal Component
 */
let AllowModalComponent = class AllowModalComponent {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.allow = false;
    }
    ngOnInit() {
        setTimeout(function () { this.allow = true; console.log(this.allow); }.bind(this), 5000);
    }
    cancel() {
        this.httpClient.post('market/order/resetorder', { order_id: +this.data.order_id }).subscribe((data) => {
            this.success();
            this.modal.destroy();
        });
    }
    close() {
        this.modal.destroy();
    }
};
AllowModalComponent.ctorParameters = () => [
    { type: SharedHttp }
];
AllowModalComponent = __decorate([
    Component({
        selector: 'ecd-allow',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./allow-modal.component.html")).default
    })
], AllowModalComponent);
export { AllowModalComponent };
